import React from "react";

import './CallUsButton.css';

const CallUsButton = props => {
    const cellphone = "8338511369";
    const handleButtonClick = () => {
        window.location.href = `tel:${cellphone}`;
    };
    return (

        <button className="call-us-button" onClick={handleButtonClick} style={{ fontSize: '1.1rem', color: 'rgba(0, 60, 134, 1)', fontWeight: '700' }}>
            {props.phonenumber}
        </button>

    );
};

export default CallUsButton;